import requests from "@/common/fetch";
import { Result, mockResponse } from "../common";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import * as I from "./interface";
import mockData from "./mock.json";

/** 查询品牌直推计划一跳素材详细信息 */
export const queryBrandPlanCvtrDetail = (
  params: I.QueryBrandPlanCvtrDetailParams
): Result<I.QueryBrandPlanCvtrDetailResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/brandPrmt/planDetail/crtv",
      toUnderCase(params)
    )
  );
};

/** 查询品牌直推计划一跳人群包详细信息 */
export const queryBrandPlanLabelDetail = (
  params: I.QueryPlanLabelDetailParams
): Result<I.QueryPlanLabelDetailResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/brandPrmt/planDetail/label",
      toUnderCase(params)
    )
  );
};

/** 投放数据概览 */
export const queryOverviewData = (
  params: I.QueryOverviewDataParams,
  isMock?: boolean
): Result<I.QueryOverviewDataResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/promotion_effect_v2/overview",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryOverviewDataResult);
};

/** 查询品牌直推指定计划组详细信息 */
export const queryPlanGroupDetail = (
  params: I.QueryPlanGroupDetailParams
): Result<I.QueryPlanGroupDetailResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/brandPrmt/groupDetail",
      toUnderCase(params)
    )
  );
};

/** 查询联合活动指定计划组详细信息 */
export const queryUnionActDetail = (
  params: I.QueryUnionActDetailParams
): Result<I.QueryUnionActDetailResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/unionAct/groupDetail",
      toUnderCase(params)
    )
  );
};

/** 查询联合活动计划一跳素材详细信息 */
export const queryUnionActPlanCrtvDetail = (
  params: I.QueryUnionActPlanCrtvDetailParams
): Result<I.QueryUnionActPlanCrtvDetailResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/unionAct/planDetail/crtv",
      toUnderCase(params)
    )
  );
};

/** 查询联合活动计划二跳商品详细信息 */
export const queryUnionActPlanGoodsDetail = (
  params: I.QueryUnionActPlanGoodsDetailParams
): Result<I.QueryUnionActPlanGoodsDetailResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/unionAct/planDetail/goods",
      toUnderCase(params)
    )
  );
};

/** 查询联合活动计划一跳人群包详细信息 */
export const queryUnionActPlanLabelDetail = (
  params: I.QueryPlanLabelDetailParams,
  isMock?: boolean
): Result<I.QueryPlanLabelDetailResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/promotion_effect_v2/unionAct/planDetail/label",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryUnionActPlanLabelDetailResult);
};

/** 查询联合活动计划二跳店铺详细信息 */
export const queryUnionActPlanMallDetail = (
  params: I.QueryUnionActPlanMallDetailParams
): Result<I.QueryUnionActPlanMallDetailResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/unionAct/planDetail/mall",
      toUnderCase(params)
    )
  );
};

/** 查询时间范围内所有计划信息 */
export const queryBrandAdPlanList = (
  params: I.QueryBrandAdPlanListParams
): Result<I.QueryBrandAdPlanListResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/promotion_effect_v2/brandAdPlan/list",
      toUnderCase(params)
    )
  );
};
